import Observer from 'src/utils/Observer';

import MessageManager from './MessageManager';

/**
 * @typedef {object} MessageData
 * @property {number} [duration]
 * @property {string} message
 * @property {string} title
 * @property {string} [toolName]
 */

/** @type {Observer<MessageData>} */
const messageObserver = new Observer();

export const messageManager = new MessageManager();

messageObserver.subscribe(message => {
  messageManager.addMessage(message);
});

export default messageObserver;
